<form [formGroup]="documentForm" class="sectionBlock" (ngSubmit)="returnDocumentPic()">
    <!-- Controls to select file by file browser or Camera -->
    <div>
        <!-- Document Number -->
        <div class="row p-2" *ngIf="fileDataConfig?.showDocumentNumber">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <label class="pt-2">Document Number</label>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <input type="text" class="form-control" placeholder="Document Number" formControlName="documentNumber">
            </div>
        </div>


        <!-- Document Date -->
        <div class="row p-2" *ngIf="fileDataConfig?.showDocumentDate">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <label class="pt-2">Document Date</label>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <p-calendar formControlName="documentDate" dateFormat="dd/mm/yy" showIcon="true" appendTo="body"
                    placeholder="Document Date"></p-calendar>
            </div>
        </div>

        <input type="file" #docInputFile accept=".jpg,.jpeg,.png,.svg,.pdf" formControlName="Document"
            style="border:1px solid black;padding-top: 10px;padding-bottom: 10px;padding-left: 10px;border-radius: 5px;"
            (change)="setBrowsedPic('documentPic',$event)">
        <!-- Control for Camera -->

        <i class="pi pi-camera pi-icons" (click)="displayCamera('{{ recordFor }}',' {{ picFor }}')"
            style="font-size: 1.5rem; margin-top: 37px; margin-left: 10px;position:relative;"></i>
        &nbsp;
        <app-camera *ngIf="displayCameraDialogue" [picMetaData]="cameraPicData"
            (getPicture)="receiveCapturedImage($event)">
        </app-camera>
        <!-- Camera control ends here -->
    </div>


    <!-- Display browsed/clicked image-->
    <div class="imgUploadBox">
        <img class="webcam-image"
            *ngIf="(fileDataConfig?.documentByte  || currentFileBytes) && fileDataConfig?.fileType != 'pdf'"
            [src]="fileDataConfig?.documentByte  || currentFileBytes" />
        <iframe class="imgUploadBox"
            *ngIf="(fileDataConfig?.documentByte  || currentFileBytes) && fileDataConfig?.fileType == 'pdf'"
            [src]="pdfFileObject" width="100%" height="100%" style="padding-top: 16px; height: 300px;"></iframe>
    </div>
    <!-- Buttons to cancel or save pic upload -->
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="ClosePicModal()" data-dismiss="modal">Close</button>
        <button type="submit" class="btn btn-success" [disabled]="!enableSubmit" data-dismiss="modal">Submit</button>
    </div>
</form>